// export default {
//   // All elemets with the class 'selectable' selectable.
//   selectables: ['.selectable']
// }

export default {
  // Class for the selection-area-element
    class: 'selection-area',
    selectedClass: 'selected',
    // document object - if you want to use it within an embed document (or iframe)
    frame: document,

    // px, how many pixels the point should move before starting the selection (combined distance).
    // Or specifiy the threshold for each axis by passing an object like {x: <number>, y: <number>}.
    startThreshold: 10,

    // Disable the selection functionality for touch devices
    disableTouch: false,

    // On which point an element should be selected.
    // Available modes are cover (cover the entire element), center (touch the center) or
    // the default mode is touch (just touching it).
    mode: 'touch',

    // Behaviour on single-click
    // Available modes are 'native' (element was mouse-event target) or 
    // 'touch' (element got touched)
    tapMode: 'native',

    // Enable single-click selection (Also disables range-selection via shift + ctrl)
    singleClick: true,

    // Query selectors from elements which can be selected
    selectables: ['.seat'],

    // Query selectors for elements from where a selection can be start
    startareas: ['html'],

    // Query selectors for elements which will be used as boundaries for the selection
    boundaries: ['.beach'],

    // Query selector or dom node to set up container for selection-area-element
    selectionAreaContainer: 'body',

    // On scrollable areas the number on px per frame is devided by this amount.
    // Default is 10 to provide a enjoyable scroll experience.
    scrollSpeedDivider: 10,

    // Browsers handle mouse-wheel events differently, this number will be used as 
    // numerator to calculate the mount of px while scrolling manually: manualScrollSpeed / scrollSpeedDivider
    manualScrollSpeed: 750,

  //  ------------------------------------------
  // SELECT
  //  ------------------------------------------


  // selection.on('beforestart', evt => {
    
  //   // Use this event to decide whether a selection should take place or not.
  //   // For example if the user should be able to normally interact with input-elements you 
  //   // may want to prevent a selection if the user clicks such a element:
  //   // selection.on('beforestart', ({oe}) => {
  //   //   return oe.target.tagName !== 'INPUT'; // Returning false prevents a selection
  //   // });
    
  //   console.log('beforestart', evt);
  // }).on('start', evt => {

  //     // A selection got initiated, you could now clear the previous selection or
  //     // keep it if in case of multi-selection.
  //     console.log('start', evt);
  // }).on('move', evt => {

  //     // Here you can update elements based on their state.
  //     console.log('move', evt);
  // }).on('stop', evt => {

  //     // The last event can be used to call functions like keepSelection() in case the user wants
  //     // to select multiple elements.
  //     console.log('stop', evt);
  // });
}
